export default function assetAdminDirective() {
  return {
    template: require('./asset-admin.html'),
    controller: 'AssetAdminController',
    controllerAs: 'assetAdminVM',
    bindToController: true,
    replace: true,
  };
}
